import * as React from 'react';



export default class NewPage extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg viewBox="0 0 16 16" className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
            <g clipPath="url(#clip0_533_3904)">
            <path d="M13.9231 8.81537V15H1V2.0769H7.18462" stroke="" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M6.03121 9.26183C5.83595 9.45709 5.83595 9.77368 6.03121 9.96894C6.22647 10.1642 6.54306 10.1642 6.73832 9.96894L6.38477 9.61539L6.03121 9.26183ZM15.5002 1C15.5002 0.723858 15.2763 0.5 15.0002 0.5H10.5002C10.224 0.5 10.0002 0.723858 10.0002 1C10.0002 1.27614 10.224 1.5 10.5002 1.5H14.5002V5.5C14.5002 5.77614 14.724 6 15.0002 6C15.2763 6 15.5002 5.77614 15.5002 5.5V1ZM6.38477 9.61539L6.73832 9.96894L15.3537 1.35355L15.0002 1L14.6466 0.646447L6.03121 9.26183L6.38477 9.61539Z" fill="#727272"/>
            </g>
            <defs>
            <clipPath id="clip0_533_3904">
            <rect width="16" height="16" fill=""/>
            </clipPath>
            </defs>
      </svg>
    )
  }
}
